export default "__VITE_ASSET__Dr5Kt_Ko__"